import { green } from 'bold-ui/lib/styles/colors'
import { MetaPath } from 'util/metaPath'
import { AtendimentoProfissional } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { SoapSection } from '../SoapSection'
import { PlanoForm, PlanoFormModel } from './PlanoForm'

export interface PlanoSectionProps {
  prontuarioId: ID
  name: MetaPath<PlanoFormModel>
  isAtendimentoOdonto: boolean
  isAtendimentoProcedimentos: boolean
  atendimentoId: ID
  dataAtendimento: Instant
  atendimentoProfissional: AtendimentoProfissional
  isRegistroTardio: boolean
}

export function PlanoSection(props: PlanoSectionProps) {
  return (
    <SoapSection initial='P' title='Plano' color={green}>
      <PlanoForm {...props} />
    </SoapSection>
  )
}
